export default __webpack_public_path__ + "static/blob-17-79be1376e72339d608f6d33cba50055f.svg";